import React from 'react';
import { TrialDaysNotification } from './TrialDaysNotification';
import { OverdueInvoicesNotification } from './OverdueInvoicesNotification';

export function UserActionNotifications() {
  return (
    <>
      <TrialDaysNotification />
      <OverdueInvoicesNotification />
    </>
  );
}
